export default __webpack_public_path__ + "static/media/ic_next_noti.20bcce4f.svg";